import { render, staticRenderFns } from "./athleticPerformance.vue?vue&type=template&id=2d83a69a&scoped=true"
import script from "./athleticPerformance.vue?vue&type=script&lang=js"
export * from "./athleticPerformance.vue?vue&type=script&lang=js"
import style0 from "./athleticPerformance.vue?vue&type=style&index=0&id=2d83a69a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d83a69a",
  null
  
)

export default component.exports